import StepType from "./step.type";

export default class OrderedStepModel extends StepType {}
